var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollContainer",staticClass:"scroll-container"},[_c('div',{staticClass:"marquee-wrapper"},[_c('div',{ref:"container",staticClass:"marquee-container"},[_c('canvas',{ref:"canvas"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }